declare global {
  interface Window {
    dataLayer?: any[];
    gtag?: (...args: any[]) => void;
  }
}

/**
 * Initialize GA4: configure if already loaded from index.html, or inject if needed
 * Should be called once when the app starts
 * 
 * Note: The GA script tag is loaded from index.html for early initialization.
 * This function ensures proper configuration for manual page view tracking.
 */
export function initAnalytics() {
  if (typeof window === 'undefined') return;

  // GA script is loaded from index.html, so gtag should already exist
  // Just verify it's available and configured correctly
  if (!window.gtag) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('GA gtag function not found. Make sure the GA script is in index.html');
    }
    return;
  }

  // Ensure dataLayer exists (should already be set by index.html script)
  if (!window.dataLayer) {
    window.dataLayer = [];
  }

  // Configuration is already done in index.html with send_page_view: false
  // No additional initialization needed - we handle pageviews manually via React Router
}

/**
 * Track a page view
 * @param path - The pathname + search string (e.g., "/portfolio" or "/beta-request?ref=twitter")
 */
export function trackPageView(path: string) {
  if (!window.gtag) return;

  window.gtag('event', 'page_view', {
    page_path: path,
  });
}

/**
 * Generic event tracker
 * @param eventName - The name of the event (e.g., "beta_request_submitted")
 * @param params - Additional parameters to send with the event (avoid PII)
 */
export function trackEvent(
  eventName: string,
  params: Record<string, any> = {}
) {
  if (!window.gtag) return;

  window.gtag('event', eventName, params);
}

